import React from "react";

const DisplayTableIcon = () => {
  return (
    <svg viewBox="0 0 24 24">
      <path
        d="M4 6C4 5.44772 4.44772 5 5 5H19C19.5523 5 20 5.44772 20 6V18C20 18.5523 19.5523 19 19 19H5C4.44772 19 4 18.5523 4 18V6ZM6 7V9H11V7H6ZM13 7V9H18V7H13ZM11 11H6V13H11L11 11ZM13 13L13 11H18V13H13ZM11 15H6V17H11V15ZM13 17V15H18V17H13Z"
        fillRule="evenodd"
        fill="currentcolor"
        stroke="none"
      />
    </svg>
  );
};

export default DisplayTableIcon;
